/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TollCostByCountry
 */
export interface TollCostByCountry {
    /**
     * 
     * @type {string}
     * @memberof TollCostByCountry
     */
    country: string;
    /**
     * 
     * @type {number}
     * @memberof TollCostByCountry
     */
    amountInTargetCurrency: number;
}

export function TollCostByCountryFromJSON(json: any): TollCostByCountry {
    return TollCostByCountryFromJSONTyped(json, false);
}

export function TollCostByCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TollCostByCountry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country': json['country'],
        'amountInTargetCurrency': json['amountInTargetCurrency'],
    };
}

export function TollCostByCountryToJSON(value?: TollCostByCountry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country': value.country,
        'amountInTargetCurrency': value.amountInTargetCurrency,
    };
}


